import type {FC} from 'react';
import {
  Create,
  Datagrid,
  DeleteButton,
  Edit,
  EditButton,
  List,
  NumberField,
  NumberInput,
  number,
  required,
  SimpleForm,
  TextField,
  TextInput,
} from 'react-admin';

export const SpeciesList: FC = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="nameKey" label="Name" />
      <NumberField source="xorforId" label="Xorfor ID" />
      <TextField source="createdAt" label="Created" />
      <TextField source="updatedAt" label="Updated" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const SpeciesEdit: FC = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="nameKey" label="Name" validate={[required()]} />
      <NumberInput source="xorforId" label="Xorfor ID" validate={[required(), number()]} />
    </SimpleForm>
  </Edit>
);

export const SpeciesCreate: FC = () => (
  <Create>
    <SimpleForm>
      <TextInput source="nameKey" label="Name" validate={[required()]} />
      <NumberInput source="xorforId" label="Xorfor ID" validate={[required(), number()]} />
    </SimpleForm>
  </Create>
);
